module.exports = __webpack_public_path__ + "3.png?cdd6f6ed6c47970f2b045f0ffe925a09";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/3.png
// module id = 421
// module chunks = 2